"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchParam = void 0;
var searchParam = function (params) {
    var ret = "";
    if (!params) {
        return "";
    }
    var arr = Object.keys(params);
    if (!arr.length) {
        return "";
    }
    arr.forEach(function (key, index) {
        var pk = params[key];
        if (pk === null ||
            pk === undefined ||
            pk === "null" ||
            pk === "undefined") {
            return;
        }
        ret += "".concat(key, "=");
        ret += "".concat(pk);
        if (index !== arr.length - 1) {
            ret += "&";
        }
    });
    if (ret.endsWith("&")) {
        ret = ret.slice(0, ret.length - 1);
    }
    return ret;
};
exports.searchParam = searchParam;
